module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-152x152-56461d443113afa67e05865a452b3f61.png";